import http from './http-common';

class FullYarnCountService {
  getAll() {
    return http.get('/fullYarnCount');
  }

  getYarnContractFullYarnCount() {
    return http.get('/fullYarnCount/yarnContractFullYarnCount');
  }

  create(data) {
    return http.post(`/fullYarnCount/`, data);
  }

  edit(data, fullYarnCountID) {
    return http.put(`/fullYarnCount/${fullYarnCountID}`, data);
  }

  delete(id) {
    return http.delete(`/fullYarnCount/${id}`);
  }
}

export default new FullYarnCountService();
